.outlinedButton {
    width: 100%;
}
